export default {"src":"/_next/static/media/locked.789af9a8.svg","height":64,"width":47,"blurWidth":0,"blurHeight":0};